/*eslint-disable*/
import React, { useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";

// Styles for the top navigation bar
const useStyles = makeStyles({
  topNavBar: {
    backgroundColor: "#2c3e50",
    color: "white",
    padding: "0 20px",
    height: "60px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
    top: 0,
    zIndex: 1000,
    position: 'relative',
  },
  navItems: {
    display: "flex",
    alignItems: "center",
    gap: "30px",
    flex: 1,
    justifyContent: "center"
  },
  navItem: {
    padding: "8px 16px",
    cursor: "pointer",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    fontSize: "14px",
    fontWeight: "500",
    "&:hover": {
      backgroundColor: "#34495e"
    }
  },
  navItemActive: {
    padding: "8px 16px",
    cursor: "pointer",
    borderRadius: "4px",
    backgroundColor: "#3498db",
    fontSize: "14px",
    fontWeight: "600",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "20px"
  },
  rightSection: {
    display: "flex",
    alignItems: "center",
    gap: "15px",
    position: 'relative',
  },
  logo: {
    fontSize: "20px",
    fontWeight: "bold",
    color: "#3498db"
  },
  iconButton: {
    color: "white",
    padding: "8px",
    borderRadius: "4px",
    cursor: "pointer",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#34495e"
    }
  },
  badge: {
    backgroundColor: "#e74c3c",
    color: "white",
    borderRadius: "50%",
    width: "18px",
    height: "18px",
    fontSize: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    top: "-5px",
    right: "-5px"
  },
  iconWithBadge: {
    position: "relative"
  },
  mobileMenuButton: {
    display: "none",
    color: "white",
    padding: "8px",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#34495e"
    },
    "@media (max-width: 1024px)": {
      display: "block"
    }
  },
  mobileMenu: {
    display: "none",
    position: "absolute",
    top: "60px",
    left: 0,
    right: 0,
    backgroundColor: "#2c3e50",
    padding: "20px",
    boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
    zIndex: 999,
    "@media (max-width: 1024px)": {
      display: "block"
    }
  },
  mobileNavItem: {
    padding: "12px 16px",
    cursor: "pointer",
    borderRadius: "4px",
    transition: "all 0.2s ease",
    fontSize: "14px",
    fontWeight: "500",
    marginBottom: "8px",
    "&:hover": {
      backgroundColor: "#34495e"
    }
  },
  mobileNavItemActive: {
    padding: "12px 16px",
    cursor: "pointer",
    borderRadius: "4px",
    backgroundColor: "#3498db",
    fontSize: "14px",
    fontWeight: "600",
    marginBottom: "8px",
    boxShadow: "0 2px 4px rgba(0,0,0,0.2)"
  },
  // New styles for hamburger and dropdown
  hamburgerIcon: {
    cursor: "pointer",
    padding: "8px",
    borderRadius: "4px",
    "&:hover": {
      backgroundColor: "#34495e"
    }
  },
  dropdownMenu: {
    position: "absolute",
    top: "100%",
    right: "0",
    backgroundColor: "#2c3e50",
    borderRadius: "4px",
    boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
    padding: "8px 0",
    minWidth: "150px",
    zIndex: 1001,
  },
  dropdownItem: {
    padding: "12px 16px",
    cursor: "pointer",
    fontSize: "14px",
    transition: "all 0.2s ease",
    "&:hover": {
      backgroundColor: "#34495e"
    }
  },
  hamburgerBar: {
    width: "20px",
    height: "2px",
    backgroundColor: "white",
    margin: "4px 0",
    borderRadius: "2px",
  }
});

function TopNavigationBar({ currentView, onViewChange, editButton, publishButton }) {
  const styles = useStyles();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  // Navigation items from your image
  const navItems = [
    { id: "Details", label: "Details", icon: "👥" },
    { id: "media", label: "Media", icon: "🖼️" },
    { id: "Publish", label: "Publish", icon: "📰" },
  ];

  const handleNavItemClick = (itemId) => {
    onViewChange(itemId);
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleActionButtonClick = (buttonName) => {
    if (buttonName === "edit") {
      editButton();
    }

    if (buttonName === "publish") {
      publishButton();
    }

    setDropdownOpen(false);
  };

  return (
    <>
      <div className={styles.topNavBar}>
        {/* Center Section - Navigation Items (Desktop) */}
        <div className={styles.navItems} style={{ display: window.innerWidth <= 1024 ? 'none' : 'flex' }}>
          {navItems.map((item) => (
            <div
              key={item.id}
              className={currentView === item.id ? styles.navItemActive : styles.navItem}
              onClick={() => handleNavItemClick(item.id)}
            >
              {item.label}
            </div>
          ))}
        </div>

        {/* Right Section - Hamburger Menu */}
        <div className={styles.rightSection}>
          <div className={styles.hamburgerIcon} onClick={toggleDropdown}>
            <div className={styles.hamburgerBar}></div>
            <div className={styles.hamburgerBar}></div>
            <div className={styles.hamburgerBar}></div>
          </div>

          {dropdownOpen && (
            <div className={styles.dropdownMenu}>
              <div
                className={styles.dropdownItem}
                onClick={() => handleActionButtonClick("edit")}
              >
                Edit Listing
              </div>
              <div
                className={styles.dropdownItem}
                onClick={() => handleActionButtonClick("publish")}
              >
                Publish Listing
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
}

export default TopNavigationBar;